import { useSessionStorage } from './useSessionStorage';

export const SESSION_STORAGE_KEY = 'ori-pbs-was-tooltip-shown';

/**
 * Controls if tooltip was shown on this device already
 */
export const useWasTooltipShown = () => useSessionStorage(SESSION_STORAGE_KEY, false);
